// extracted by mini-css-extract-plugin
export default {"single":"single-option_single__iWXGI","selector__single":"single-option_selector__single__tez4c","select__form":"single-option_select__form__sFM7a"};